import React from 'react';
import styles from './AwairLogo.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const AwairLogo = ({
  width = 51.5,
  height = 24,
}) => {
  return (
    <svg className={cx('AwairLogo')} width={width} height={height} viewBox='0 0 104 24' xmlns='http://www.w3.org/2000/svg' style={{marginBottom: '3px'}}>
      <g id='Page-1' fill='none' fillRule='evenodd'>
        <g id='intro_0_movie' transform='translate(-323 -71)' fill='#FFF'>
          <g id='rev2_tutorial_intro' transform='translate(0 -145)'>
            <g id='rev2_tutorial_0'>
              <g transform='translate(323 216)' id='logo_awair'>
                <path d='M8.32941176,0.0423529412 L0,23.8870588 L4.89882353,23.8870588 L6.33882353,19.68 L14.7670588,19.68 L16.1788235,23.8870588 L21.0635294,23.8870588 L12.7058824,0.0423529412 L8.32941176,0.0423529412 Z M13.5105882,15.7129412 L7.65176471,15.7129412 L10.6305882,7.12941176 L13.5105882,15.7129412 Z'
                      id='Shape' fillRule='nonzero' />
                <path d='M62.9505882,0.0423529412 L58.5882353,0.0423529412 L50.2588235,23.8870588 L55.1435294,23.8870588 L56.5835294,19.68 L65.0117647,19.68 L66.4235294,23.8870588 L71.3082353,23.8870588 L63.0070588,0.197647059 L62.9505882,0.0423529412 Z M63.7694118,15.7129412 L57.9105882,15.7129412 L60.8894118,7.12941176 L63.7694118,15.7129412 Z'
                      id='Shape' fillRule='nonzero' />
                <polygon id='Path' points='45.5011765 0.0423529412 41.8023529 14.9929412 37.4682353 0.0423529412 33.9670588 0.0423529412 29.6329412 14.9929412 25.9764706 0.0423529412 21.0917647 0.0423529412 27.4447059 23.8870588 31.3552941 23.8870588 35.7176471 9.48705882 40.08 23.8870588 43.9905882 23.8870588 50.3858824 0.0423529412'
                />
                <rect id='Rectangle' x='75.176' y='0.042' width='4.687' height='23.845'
                />
                <path d='M99.36,13.0588235 L99.7694118,12.7764706 C100.291765,12.4094118 100.757647,11.9576471 101.167059,11.4352941 C101.562353,10.9129412 101.887059,10.3058824 102.127059,9.64235294 C102.367059,8.97882353 102.48,8.20235294 102.48,7.35529412 C102.48,6.35294118 102.310588,5.40705882 101.957647,4.51764706 C101.604706,3.64235294 101.096471,2.85176471 100.432941,2.20235294 C99.7694118,1.55294118 98.9364706,1.01647059 97.9905882,0.621176471 C97.0305882,0.225882353 95.9435294,0.0282352941 94.7435294,0.0282352941 L85.3976471,0.0282352941 L85.3976471,23.8729412 L90.0847059,23.8729412 L90.0847059,14.3717647 L93.7411765,14.3717647 C94.1223529,14.3717647 94.8141176,14.3717647 95.3223529,14.3576471 L98.4282353,23.8729412 L103.327059,23.8729412 L99.36,13.0588235 Z M97.7788235,7.32705882 C97.7788235,8.24470588 97.4682353,9.00705882 96.8611765,9.57176471 C96.2541176,10.1364706 95.4352941,10.4329412 94.4188235,10.4329412 L90.0705882,10.4329412 L90.0705882,4.22117647 L94.4329412,4.22117647 C95.4494118,4.22117647 96.2682353,4.51764706 96.8752941,5.08235294 C97.4682353,5.66117647 97.7788235,6.40941176 97.7788235,7.32705882 Z'
                      id='Shape' fillRule='nonzero' />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default AwairLogo;


// WEBPACK FOOTER //
// ./src/app/intro/components/Logo/AwairLogo.js